<script lang="ts">
    import { getContent } from "../../api"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import { _ } from "svelte-i18n"
    export let path: string

    let loading = true
    let content: Content

    function load() {
        loading = true
        getContent(path)
            .then((c) => {
                content = c
            })
            .finally(() => {
                loading = false
            })
    }

    $: if (path) load()
</script>

<section class="section_padding">
    <div class="container">
        <div class="content">
            {#if loading}
                <br />
                <MiniLoader />
            {:else if content}
                {#each content.blocks || [] as b}
                    <div class="block">
                        {#if b.title}
                            <h2>{b.title}</h2>
                        {/if}
                        {#if b.subtitle}
                            <div class="subtitle">{b.subtitle}</div>
                        {/if}
                        {#if b.text}
                            <div class="text">{@html b.text}</div>
                        {/if}
                    </div>
                {/each}
            {:else}
                {@html $_("general.pageNotFound", {
                    values: {
                        path: path,
                    },
                })}
            {/if}
        </div>
    </div>
</section>
